import React from 'react';
import { pridi } from '../fonts';

interface GameTitleProps {
  logoSrc: string;
}

const GameTitleMobile: React.FC<GameTitleProps> = ({ logoSrc }) => {
  return (
    <div className='m-0'>
      <div className="flex items-center gap-2">
        <img src={logoSrc} alt="StickerChain logo" className="w-9 h-9 rounded-md" />
        <div className="min-w-0">
          <h1 className={`truncate text-2xl tracking-wider max-[360px]:text-xl max-[340px]:text-lg max-[340px]:tracking-wide ${pridi.className}`}>StickerChain</h1>
          <p className='truncate text-sm text-gray-400 font-medium tracking-tight mt-0 leading-tight max-[360px]:text-[11px]'>
            Slap the Planet!
          </p>
        </div>
      </div>
    </div>
  );
};

export default GameTitleMobile;
